import { makeStyles } from "@material-ui/core/styles";
import { Colors } from "constants/constants";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    boxSizing: "border-box",
    gap: "10px",
    borderBottom: "none",
  },
  filter: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    boxSizing: "border-box",
    justifyContent: "space-between",
    padding: theme.spacing(1),
    flexWrap: "wrap",
    boxShadow: "none",
    borderRadius: 15,
    borderBottom: "#e8e9ee 2px solid",
    "@media (max-width: 1200px)": {
      justifyContent: "center",
    }
  },
  selectors: {
    display:"flex",
    width:400,
    gap: theme.spacing(2),
    margin: theme.spacing(0, 1),
    "@media (max-width: 700px)": {
      flexDirection: "column",
    },
  },
  tableRoot: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    maxHeight: "calc(100vh - 180px)",
  },
  tableContainer: {
    boxShadow: "none",
    borderRadius: 15,
    borderBottom: "#e8e9ee 1.5px solid",
  },
  tableBoldBorderCell: {
    fontWeight: 800,
    "& :not(:last-child)": {
      borderBottom: `2px solid ${theme.palette.primary.dark}`,
    }
  },
  rightBoldBorderCell: {
    borderRight: `1px solid ${theme.palette.primary.dark}`,
  },
  emptyTable: {
    marginTop: theme.spacing(2),
    alignSelf: "center",
  },
  tableCell: {
    padding: theme.spacing(1, 1.5, 1, 0),
    cursor: "default",
    textAlign: "center",
  },
  tableCellPaddingLeft: {
    paddingLeft: theme.spacing(1.5)
  },
  tableHeadWhiteCell: {
    background: Colors.WHITE,
  },
  tableHeadCell: {
    padding: theme.spacing(2),
  },
  tableDarkCell: {
    color: Colors.WHITE,
    cursor: "default",
    textAlign: "center",
  },
  smallTableFont: {
    fontSize: "10px",
    
  },
  button: {
    marginRight: theme.spacing(1),
    textTransform: "none",
  },
  tableCellWeekName: {
    cursor: "default",
    textAlign: "center",
    background: theme.palette.primary.light,
    color: Colors.WHITE,
  },
  rightBorderCell: {
    borderRight: "1px solid lightGrey",
  },
  bottomBoldBorderCell: {
    borderBottom: "3px solid lightGrey",
  },
  greenCell: {
    color: Colors.GREEN,
    width: "100%",
    maxHeight: "30px",
  },
  redCell: {
    color: Colors.RED,
    width: "100%",
    maxHeight: "30px",
  },
  greenAlert: {
    background: "#cefad0",
  },
  redAlert: {
    background: "#ffe3e6",
  },
  weekSelectorBox: {
    display: "flex",
    justifyContent: "space-between",
  },
  tableHeadTypography: {
    fontSize: 16,
    fontWeight: 600,
  }
}));
